import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';
import { t } from '@/i18n';
import { Button } from './Button';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn('size-4 animate-spin text-ink-faint', className)} aria-hidden="true" />;
}

export function LoadingBlock({ label = t.common.loading }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 px-4 py-12 text-sm text-ink-dim">
      <Spinner />
      {label}
    </div>
  );
}

export function EmptyState({
  title,
  body,
  action,
  className,
}: {
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('px-4 py-12 text-center', className)}>
      <p className="text-sm font-medium text-ink">{title}</p>
      {body ? <p className="mx-auto mt-1 max-w-md text-xs text-ink-dim">{body}</p> : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  );
}

export function ErrorState({ onRetry, message }: { onRetry?: () => void; message?: string }) {
  return (
    <EmptyState
      title={message ?? t.errors.server}
      body="Данните не се заредиха. Ако се повтори, проверете дали API-то работи на адреса от VITE_API_URL."
      action={
        onRetry ? (
          <Button variant="secondary" onClick={onRetry}>
            {t.common.retry}
          </Button>
        ) : null
      }
    />
  );
}

/** Сивата плоча по време на зареждане — по-спокойна от подскачащ спинер. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded bg-raised', className)} />;
}
